import React from 'react'
import DefaultInput, { TextFieldProps } from '@mui/material/TextField'
import constants from 'utils/constants'

const inputGreen = {
  color: constants.colors.green,
  borderBottomColor: constants.colors.green,
}
const inputWhite = {
  color: constants.colors.white,
  borderBottomColor: constants.colors.white,
}

/* eslint-disable react/jsx-props-no-spreading */
const Input = (props: TextFieldProps) => {
  const {
    variant,
  } = props
  return (
    <DefaultInput
      variant={variant ?? 'standard'}
      sx={{
        input: inputWhite,
        label: inputWhite,
        textarea: inputWhite,
        '.MuiInput-root': {
          ':before': inputWhite,
          ':hover:before': {
            borderBottom: `2px solid ${constants.colors.green} !important`,
          },
        },
        '.Mui-focused': {
          inputGreen,
          color: `${constants.colors.green} !important`,
          fieldset: {
            borderColor: `${constants.colors.green} !important`,
          },
          ':after': inputGreen,
        },
        fieldset: {
          borderColor: 'white',
        },
        '.MuiOutlinedInput-root': {
          borderColor: 'white',
          ':hover fieldset': {
            borderColor: constants.colors.green,
          },
        },
      }}
      {...props}
    />
  )
}
export default Input
